/**
 * 全ての UI 文字列は { ja, vi } の両方を必ず持つ。
 * 片言語だけの文字列を作らない (不変条件 I3)。
 */
export interface Bilingual {
  readonly ja: string;
  readonly vi: string;
}

export function bi(ja: string, vi: string): Bilingual {
  return { ja, vi };
}
